import store from '@/store';
import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {ResponseDataType} from "@/form/form.types";
import { prepareFormData } from '@/store/utils/formDataHelper';
import { IVacancy, IVacancyListItem, VacancyResponseType } from '@/entity/Settings/vacancy.types';
import { SiteVacancyRequestType } from '@/form/Settings/site/vacancy.types';
import { SiteVacancyUpdateFormRequestType } from '@/form/Settings/site/vacancyUpdate.types';


@Module({
    namespaced: true,
    name: 'vacancy',
    store,
    dynamic: true
})

class VacancyModule extends VuexModule implements IStoreReady  {
    vacancy: IVacancy | null = null
    vacancyItem: IVacancyListItem | null = null
    vacancyLoaded = false
    vacancyItemLoaded = false
    ready = false

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ vacancy: IVacancy;  vacancyLoaded: boolean }> {
        let vacancyLoaded = false;
        const vacancy = await store.$repository.vacancy.fetchAll(prepareFormData(data));
        if(vacancy){
            vacancyLoaded = true;
        }
        return { vacancy, vacancyLoaded}
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ vacancyItem: IVacancyListItem  ; vacancyItemLoaded: boolean }> {
        let vacancyItemLoaded = false;
        const vacancyItem = await store.$repository.vacancy.fetchData(data);
        if (vacancyItem) {
            vacancyItemLoaded = true;
        }
        return { vacancyItem, vacancyItemLoaded};
    }

    @Action({rawError: true})
    async create(data: SiteVacancyRequestType): Promise<ResponseDataType> {
        console.log(data);
        return await store.$repository.vacancy.create(data);
    }
    @Action({rawError: true})
    async update(data: SiteVacancyUpdateFormRequestType): Promise<ResponseDataType> {
        return await store.$repository.vacancy.update(data);
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        return await store.$repository.vacancy.delete(data);
    }
    @Mutation
    setReady(st:boolean){
        this.ready = st
    }
    
}

export const VacancyStore = getModule(VacancyModule);